import React from 'react';

const SubscriptionIcon = ({ width = 15, fill = '#7E818B' }) => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M19 3H5C3.89 3 3 3.89 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.89 20.1 3 19 3ZM19 19H5V5H19V19Z" />
      <path d="M12 6C13.66 6 15 7.34 15 9C15 10.66 13.66 12 12 12C10.34 12 9 10.66 9 9C9 7.34 10.34 6 12 6Z" />
      <path d="M6 16.5C6 14.5 10 13.5 12 13.5C14 13.5 18 14.5 18 16.5V18H6V16.5Z" />
    </svg>
  );
};

export default SubscriptionIcon;